import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import authToken from '~/mixins/authToken';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import ModalOverlay from '~/components/common/ModalOverlay.vue';
import ConfirmationScreen from '~/components/members-area/ConfirmationScreen.vue';
import DisclosureModal from '~/components/members-area/DisclosureModal.vue';
import { PLAN_ENCODE_MAP } from '~/assets/data/plan-maps.json';
import getPlans from '~/utils/plans';
export default {
  name: 'ScheduledPayment',
  components: {
    LoadingOverlay,
    ModalOverlay,
    ConfirmationScreen,
    DisclosureModal
  },
  mixins: [authToken],
  layout: 'no-header',
  data() {
    return {
      processing: true,
      success: false,
      error: null,
      memberProfile: null,
      lastCharge: null,
      disclosureFile: '',
      showDisclosure: false,
      policyTimestamps: {},
      planAutopay: false,
      showCancelModal: false
    };
  },
  head: {
    htmlAttrs: {
      class: 'theme-light'
    }
  },
  computed: {
    plans() {
      var _this$memberProfile;
      return getPlans((_this$memberProfile = this.memberProfile) === null || _this$memberProfile === void 0 ? void 0 : _this$memberProfile.alternate_funnel);
    },
    plan() {
      var _this$memberProfile2;
      return (_this$memberProfile2 = this.memberProfile) === null || _this$memberProfile2 === void 0 ? void 0 : _this$memberProfile2.plan;
    },
    lastChargeAuthorized() {
      var _this$lastCharge, _this$lastCharge2;
      return Boolean(((_this$lastCharge = this.lastCharge) === null || _this$lastCharge === void 0 || (_this$lastCharge = _this$lastCharge.metadata) === null || _this$lastCharge === void 0 ? void 0 : _this$lastCharge.next_charge_policy_consent_id) && !((_this$lastCharge2 = this.lastCharge) !== null && _this$lastCharge2 !== void 0 && (_this$lastCharge2 = _this$lastCharge2.metadata) !== null && _this$lastCharge2 !== void 0 && _this$lastCharge2.revocation_date));
    },
    achPolicyMetadata() {
      var _this$memberProfile3, _this$memberProfile4, _this$memberProfile5;
      if (!this.lastCharge || !this.plan) return {};
      dayjs.extend(AdvancedFormat);
      const rawProcessDate = dayjs(this.lastCharge.next_charge_date);
      const encodedCycle = PLAN_ENCODE_MAP[0][this.plan.billingCycle];
      const currentPlanCost = this.plans[this.plan.selectedPlan].price[this.plan.billingCycle];
      return {
        first_name: (_this$memberProfile3 = this.memberProfile) === null || _this$memberProfile3 === void 0 ? void 0 : _this$memberProfile3.form.first_name,
        // name at timestamp
        last_name: (_this$memberProfile4 = this.memberProfile) === null || _this$memberProfile4 === void 0 ? void 0 : _this$memberProfile4.form.last_name,
        // name at timestamp
        account_last_four: (_this$memberProfile5 = this.memberProfile) === null || _this$memberProfile5 === void 0 || (_this$memberProfile5 = _this$memberProfile5.bank_account) === null || _this$memberProfile5 === void 0 ? void 0 : _this$memberProfile5.mask,
        plan_type: PLAN_ENCODE_MAP[1][this.plan.selectedPlan],
        billing_cycle: encodedCycle,
        basic_plan_cost: this.plans[0].price[this.plan.billingCycle],
        rewards_plan_cost: this.plans[1].price[this.plan.billingCycle],
        // display only
        current_date: dayjs().format('MMMM D, YYYY'),
        process_day: rawProcessDate.format('Do'),
        process_month: encodedCycle === 'annual' ? `${rawProcessDate.format('MMMM')} each year` : 'each month',
        raw_process_date: rawProcessDate,
        formatted_process_date: rawProcessDate.format('MMMM Do, YYYY'),
        formatted_plan_cost: currentPlanCost && currentPlanCost.toFixed(2)
      };
    },
    isDev() {
      return this.$config.environment === 'development' || this.$config.plaidEnv === 'sandbox';
    }
  },
  watch: {
    success(val) {
      if (val) {
        setTimeout(() => {
          this.$router.push('/app/dismiss?light=1');
        }, 3000);
      }
    }
  },
  async mounted() {
    try {
      this.memberProfile = await this.$axios.$get('/api/members/profile');
      const {
        charge
      } = await this.$axios.$get('/api/members/selfpay-authorize');
      this.lastCharge = charge;
    } catch (error) {
      this.error = error;
    }
    this.processing = false;
  },
  methods: {
    showThisDisclosure(disc) {
      this.disclosureFile = disc;
      this.showDisclosure = true;
    },
    async submit() {
      this.processing = true;
      const [policyName, policyTimestamp] = Object.entries(this.policyTimestamps)[0];
      try {
        await this.$axios.$post('/api/members/selfpay-authorize', {
          chargeId: this.lastCharge.id,
          enrollmentId: this.lastCharge.enrollment_id,
          policyName,
          policyTimestamp,
          achPolicyMetadata: this.achPolicyMetadata,
          planAutopay: this.planAutopay
        });
        this.success = true;
      } catch (error) {
        this.error = error;
      }
      this.processing = false;
    },
    async cancelPayment() {
      this.processing = true;
      this.showCancelModal = false;
      try {
        await this.$axios.$post('/api/members/selfpay-revoke', {
          chargeId: this.lastCharge.id
        });
        this.success = true;
      } catch (error) {
        this.error = error;
      }
      this.processing = false;
    },
    reloadPage() {
      window.location.reload();
    }
  }
};